import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'generarObjetoCombinaciones'
})

// Este pipe genera un arreglo de objetos de combinaciones para
// que el usuario pueda seleccionar la combinación
export class GenerarObjetoCombinacionesPipe implements PipeTransform {

  transform(servicio: any):Array<any> {

    // Arreglo vacío de combinaciones
    let combinaciones:Array<any> = [];

    if(servicio.punto_origen)
    {
        // Hace un loop por todas las combinaciones
        for (let combinacionId in servicio.precioCombinaciones) {
            // Inicializa el objeto de combinación
            let objCombinacion = {
                idCombinacion : combinacionId,
                precio : servicio.precioCombinaciones[combinacionId].total,
                precioConDescuento: servicio.precioCombinaciones[combinacionId].precioConDescuento,
                descuentoAQuitarAdicional: servicio.precioCombinaciones[combinacionId].descuentoAQuitarAdicional,
                descuentoAQuitarAdmin: servicio.precioCombinaciones[combinacionId].descuentoAQuitarAdmin,
                descuentoAQuitarMark: servicio.precioCombinaciones[combinacionId].descuentoAQuitarMark,
                conceptosAdicionales : 0,
                unidades : [] // Arreglo de tipos de unidad en la combinación
            };

            // Hace un loop por los tipos de unidad que se seleccionaron en la combinación
            for(let unidadId in servicio.precioCombinaciones[combinacionId].combinacion){
                // Inicializa el objeto de unidad para la combinación
                let objUnidad = {
                    tipoDeUnidad : unidadId,
                    numeroDeUnidades : servicio.precioCombinaciones[combinacionId].combinacion[unidadId]
                };
                // Añade el objeto unidad al arreglo de unidades
                if(objUnidad.numeroDeUnidades > 0)
                objCombinacion.unidades.push(objUnidad);
            }

            // Hace un loop por los conceptos adicionales del servicio y los suma al precio final
            if (servicio.hasOwnProperty('conceptosAdicionales')) {
                for (let concepto in servicio.conceptosAdicionales){
                    objCombinacion.conceptosAdicionales += (servicio.conceptosAdicionales[concepto].precio*servicio.conceptosAdicionales[concepto].cantidad);
                }
            }

            // Añade el objeto combinación al arreglo de combinaciones a regresar al usuario
            combinaciones.push(objCombinacion);
        }
    }
    else {
        for (let combinacionId in servicio.costoCombinaciones) {
            // Inicializa el objeto de combinación
            let objCombinacion = {
                idCombinacion : combinacionId,
                precio : servicio.precioCombinaciones[combinacionId],
                conceptosAdicionales : 0,
                unidades : [] // Arreglo de tipos de unidad en la combinación
            };
            // Hace un loop por los tipos de unidad que se seleccionaron en la combinación
            for(let unidadId in servicio.costoCombinaciones[combinacionId]){
                // Inicializa el objeto de unidad para la combinación
                let objUnidad = {
                    tipoDeUnidad : unidadId,
                    numeroDeUnidades : servicio.costoCombinaciones[combinacionId][unidadId].numeroDeUnidades
                };
                // Añade el objeto unidad al arreglo de unidades
                objCombinacion.unidades.push(objUnidad);
            }
            // Hace un loop por los conceptos adicionales del servicio y los suma al precio final
            if (servicio.hasOwnProperty('conceptosAdicionales')) {
                for (let concepto in servicio.conceptosAdicionales){
                    objCombinacion.conceptosAdicionales += servicio.conceptosAdicionales[concepto].precio;
                }
            }
            // Añade el objeto combinación al arreglo de combinaciones a regresar al usuario
            combinaciones.push(objCombinacion);
        }
    }

    // Regresa el arreglo limipo de combinaciones
    return combinaciones;
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/generar-objeto-combinaciones.pipe.ts